import { StepName } from '~/core/enums';

export const requiredSteps: Partial<Record<StepName, { required: boolean }>> = {
  [StepName.designCornerRadius]: { required: true },
  [StepName.designEdge]: { required: true },
  [StepName.designShape]: { required: true },
} as const;
